import { groupAndSortSubmetrics } from '@repo/utils';
import { useMemo } from 'react';
import usePreviousMetricValues from './usePreviousMetricValues';
import useSubMetricEvaluations from './useSubMetricEvaluations';

export default function useFetchAndGroupCategories() {
  const { data: metrics, isLoading: metricsLoading } =
    useSubMetricEvaluations();
  const { data: previous, isLoading: previousValuesLoading } =
    usePreviousMetricValues();

  const categories = useMemo(() => {
    const versionExcluded = new Set(previous.versionExcludedNames);
    return groupAndSortSubmetrics(
      (metrics ?? []).map(submetric => ({
        ...submetric,
        previous_user_values: previous.previousValues[submetric.name] ?? [],
        previous_kit_count: previous.previousKitCount,
        previous_values_version_excluded: versionExcluded.has(submetric.name),
      })),
    );
  }, [metrics, previous]);

  const loading = metricsLoading || previousValuesLoading;

  return { categories, metrics, loading };
}
